import React from 'react';
import { connect } from 'react-redux';
import { compose, withProps, lifecycle } from "recompose";
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { withScriptjs }  from "react-google-maps";
import { StandaloneSearchBox } from "react-google-maps/lib/components/places/StandaloneSearchBox";
import { AddressForm } from '../../components/Address'


const PlacesWithStandaloneSearchBox = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDdv0AFcirN-h8rPLJLfyS53mCGXFbBgBY&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
  }),
  lifecycle({
    componentWillMount() {
      const refs = {}
      this.setState({
        places: [],
        onSearchBoxMounted: (ref) => {
          refs.searchBox = ref;

        },
        onPlacesChanged: () => {
          // this.props.setFormFocus();
          const places = refs.searchBox.getPlaces();
          this.props.setFormChange(places[0].formatted_address,false);
          this.props.setFormBLUR(places[0].formatted_address,false);
          this.setState({
            places,
          });
        },
      })
    },
  }),
  withScriptjs
)((props) =>
{

  if (props.places[0]){
    return(
      <div data-standalone-searchbox=""  >
        <StandaloneSearchBox
          ref={props.onSearchBoxMounted}
          bounds={props.bounds}
          onPlacesChanged={props.onPlacesChanged}
        >
        <AddressForm addressComponents={props.places[0].address_components} />
        </StandaloneSearchBox>
</div>

)
}
return(
<div data-standalone-searchbox="">
  <StandaloneSearchBox
    className="form-control"
    ref={props.onSearchBoxMounted}
    bounds={props.bounds}
    onPlacesChanged={props.onPlacesChanged}
  >
    <input
      className="form-control"
      type="text"
      defaultValue={props.initvalue}
      placeholder={props.translate('enter-adress-placeholder')}
    />
  </StandaloneSearchBox>
</div>)
}
);
let InputAddress = ({ input, placeholder, type, claasName, beforeInput, afterInput, initvalue,inputProps, translate, setFormChange,setFormBLUR, setFormFocus, message, meta: { asyncValidating, touched, error, val } }) => {
  return (
    <div  >
      <div className="form-control" >
        <PlacesWithStandaloneSearchBox  setFormChange={setFormChange} setFormFocus={setFormFocus} setFormBLUR={setFormBLUR} initvalue={initvalue} translate={translate} />
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    message: state.Flash.message,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFormBLUR: (message) => {
      dispatch(
        {
          type: '@@redux-form/BLUR',
           meta:{

          form: "EditAddress",
          field: "address",
          touch: true
          },
          payload:message
        }
      );
    },

    setFormFocus: () => {
      dispatch(
        {
          type: '@@redux-form/FOCUS',
           meta:{

          form: "EditAddress",
          field: "address",
          touch: true
          },
        }
      );
    },
    setFormChange: (message, success) => {
      dispatch(
        {
          type: '@@redux-form/CHANGE',
           meta:{

          form: "EditAddress",
          field: "address",
          touch: true
          },
        payload:message
        }
      );
    },
  }
}

InputAddress = connect(
  mapStateToProps,
  mapDispatchToProps
)(InputAddress);



export default InputAddress;



// WEBPACK FOOTER //
// ./src/lib/forms/InputAddress.js